module.exports = __webpack_public_path__ + "assets/img/4-2-en.bc61fc06.png";